"use strict";

var _nprogress = require("nprogress");

var _nprogress2 = _interopRequireDefault(_nprogress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onClientEntry = function (a) {
    var pluginOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { color: "#29d" };

    window.___emitter.on("onDelayedLoadPageResources", function () {
        _nprogress2.default.configure(pluginOptions);
        _nprogress2.default.start();
    });
    window.___emitter.on("onPostLoadPageResources", function () {
        _nprogress2.default.done();
    });

    // Inject styles.
    var styles = "#nprogress {\n    pointer-events: none;\n}\n#nprogress .bar {\n    background: " + pluginOptions.color + ";\n    position: fixed;\n    z-index: 1031;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n}\n#nprogress .peg {\n    display: block;\n    position: absolute;\n    right: 0px;\n    width: 100px;\n    height: 100%;\n    box-shadow: 0 0 10px " + pluginOptions.color + ", 0 0 5px " + pluginOptions.color + ";\n    opacity: 1.0;\n    -webkit-transform: rotate(3deg) translate(0px, -4px);\n    -ms-transform: rotate(3deg) translate(0px, -4px);\n    transform: rotate(3deg) translate(0px, -4px);\n}\n#nprogress .spinner {\n    display: block;\n    position: fixed;\n    z-index: 1031;\n    top: 15px;\n    right: 15px;\n}\n#nprogress .spinner-icon {\n    width: 18px;\n    height: 18px;\n    box-sizing: border-box;\n    border: solid 2px transparent;\n    border-top-color: " + pluginOptions.color + ";\n    border-left-color: " + pluginOptions.color + ";\n    border-radius: 50%;\n    -webkit-animation: nprogress-spinner 400ms linear infinite;\n    animation: nprogress-spinner 400ms linear infinite;\n}\n.nprogress-custom-parent {\n    overflow: hidden;\n    position: relative;\n}\n.nprogress-custom-parent #nprogress .spinner,\n.nprogress-custom-parent #nprogress .bar {\n    position: absolute;\n}\n@-webkit-keyframes nprogress-spinner {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n@keyframes nprogress-spinner {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n";

    var node = document.createElement("style");
    node.id = "nprogress-styles";
    node.innerHTML = styles;
    document.head.appendChild(node);
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-nprogress/gatsby-browser.js
// module id = 413
// module chunks = 231608221292675